import type { FilialResumo } from './types';

/** Rótulo da filial em selects e cabeçalhos (evita string vazia quando o nome não veio do servidor). */
export function filialLabel(f: FilialResumo): string {
  const nome = f.nome?.trim();
  if (nome) return f.codigo?.trim() ? `${nome} (${f.codigo})` : nome;
  if (f.codigo?.trim()) return `Cód. ${f.codigo}`;
  return 'Filial sem nome';
}
